module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day-parts-legend"
  }, _vm._l((_vm.sortedDayParts), function(part) {
    return _c('div', {
      staticClass: "day-parts-legend__part",
      class: {
        'day-parts-legend__part--selected': _vm.isSelected(part.id)
      },
      on: {
        "click": function($event) {
          return _vm.emitDayPart(part.id)
        }
      }
    }, [_c('span', {
      staticClass: "day-parts-legend__part-color",
      style: ({
        backgroundColor: part.color
      })
    }), _vm._v("\n    " + _vm._s(part.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36008a74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/lasGraphs/dayParts/components/DayPartsLegend.vue
// module id = 1865
// module chunks = 0